import { FlagsConfig, StaticFlags } from '../StaticFlagsHook.types';
import { AppSubdomains } from 'src/types/common';

export const flagsConfig: FlagsConfig = {
  [AppSubdomains.Pari]: {
    strategy: 'enabled',
    exceptions: [StaticFlags.EnableRecommendedCategories],
  },
  [AppSubdomains.Homebar]: {
    strategy: 'disabled',
    exceptions: [StaticFlags.EnableAddressChange],
  },
  [AppSubdomains.Terea]: {
    strategy: 'disabled',
    exceptions: [StaticFlags.EnableSignUp, StaticFlags.EnableSocialLogin],
  },
};
